export default "__VITE_ASSET__Ctsmx_OK__"